import { log } from './logger.js';

function gtag() {
  window.dataLayer.push(arguments);
}

let initialized = false;

function collectPageViewStat() {
  if (!window.googleAnalyticsId) {
    return;
  }

  if (!initialized) {
    window.dataLayer = window.dataLayer || [];
    gtag('js', new Date());
    gtag('config', window.googleAnalyticsId, {
      send_page_view: false,
    });
    initialized = true;
  }

  log(`[history] collect page view stats for '${document.title}'`);
  return gtag('event', 'page_view', {
    page_title: document.title,
    page_location: location.href,
    page_path: location.pathname,
    send_to: window.googleAnalyticsId,
  });
}

export { collectPageViewStat };
